<template>
    <div>
        <input type="hidden" :value="ValidateFigTransp">
        <div class="form-group row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="d-flex justify-content-between align-items-baseline">
                            <!-- <h4>Figura de Transporte</h4> -->
                            <label class="col-form-label"><em>Los campos marcados con un * son obligatorios</em></label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" v-show="false">
                        <label for="CveTransporteTxT" class="form-label">Clave de Transporte*</label>
                        <input name="CveTransporteTxT" id="CveTransporteTxT" type="text" value="" class="form-control"
                            readonly>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                        <div class="form-group row mt-3">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <h4>Figura</h4>
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <button type="button" @click="AgregarFigura()"
                                    title="Agregar nueva figura" class="btn btn-primary"><i class="fa fa-plus-circle"></i>
                                    Agregar</button>
                            </div>
                        </div>
                        <div v-show="ListaFiguras.length">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a v-for="(figura, index) in ListaFiguras" class="nav-link" :key="index"
                                        :class="{ 'active': figura.Active, 'text-secondary': !figura.Active }" 
                                        @click="ManageTabs(ListaFiguras, index)" style="cursor: pointer;">
                                        Figura {{ index + 1 }}
                                    </a>
                                </div>
                            </nav>
                            <div class="tab-content" id="nav-tabContent-figtransp">
                           
                                <Transition v-for="(figura, index2) in ListaFiguras" :key="index2" >
                                    <div class="tab-pane fade" :class="{ 'show active': figura.Active }" >
                                        <div class="container-tab">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-2 text-end">
                                                <button type="button" @click="BorrarFigura(index2)" v-b-tooltip.hover.Top
                                                    title="Borrar figura" class="btn btn-danger"><i
                                                        class="fa fa-trash"></i></button>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'TipoFigura' + index2" class="form-label">Tipo
                                                        Figura*</label>
                                                    <select :name="'TipoFigura' + index2" :id="'TipoFigura' + index2"
                                                        v-model="figura.TipoFigura" class="form-control form-select">
                                                        <option value="">Seleccione una opción</option>
                                                        <option v-for="(item, index3) in DataInicial.figuras" :key="index3">
                                                            {{
                                                                item.Nombre }}</option>
                                                    </select>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'NombreFigura' + index2" class="form-label">Nombre
                                                        Figura*</label>
                                                    <div class="input-group">
                                                        <input :name="'NombreFigura' + index2" :id="'NombreFigura' + index2"
                                                            type="text" @input="AutocompChofer(figura);"
                                                            class="form-control text-capitalize ps-2"
                                                            v-model="figura.NombreFigura" maxlength="254">
                                                        <button type="button" @click="AutocompChofer(figura)"
                                                            class="btn btn-outline-primary mb-0">
                                                            <i :class="figura.IconSearch"></i>
                                                        </button>
                                                    </div>
                                                    <div class="position-relative">
                                                        <ul class="busqueda list-group">
                                                            <li v-for="(elem, index3) in figura.AutocompChoferList"
                                                                @click="SetDataChoferFig(figura, elem.IdChofer)"
                                                                :key="index3" class="bss list-group-item text-capitalize">
                                                                <i class="fa fa-user fa-1 me-2"></i> {{ elem.Nombre + ' '+elem.ApellidoPat+' '+elem.ApellidoMat }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'RFCFigura' + index2" class="form-label">RFC Figura*</label>
                                                    <input :name="'RFCFigura' + index2" :id="'RFCFigura' + index2" type="text"
                                                        class="form-control" v-model="figura.RFCFigura">
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'NumLicencia' + index2" class="form-label">N°
                                                        Licencia</label>
                                                    <input :name="'NumLicencia' + index2" :id="'NumLicencia' + index2"
                                                        type="text" v-model="figura.NumLicencia" class="form-control"
                                                        maxlength="16">
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'NumRegIdTribFigura' + index2" class="form-label">N° Registro
                                                        IdTributario
                                                        Figura</label>
                                                    <input :name="'NumRegIdTribFigura' + index2"
                                                        :id="'NumRegIdTribFigura' + index2" type="text" class="form-control"
                                                        v-model=figura.NumRegIdTribFigura>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <label :for="'ResidenciaFiscalFigura' + index2"
                                                        class="form-label">Residencia Fiscal Figura</label>
                                                    <select :name="'ResidenciaFiscalFigura' + index2"
                                                        :id="'ResidenciaFiscalFigura' + index2"
                                                        v-model="figura.ResidenciaFiscalFigura"
                                                        class="form-control form-select">
                                                        <option value="">Seleccione una opción</option>
                                                        <option v-for="(item, index3) in DataInicial.pais" :key="index3"
                                                            :value="item.Clave">
                                                            {{ item.Nombre }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group row mt-5">
                                                <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                    <h4>Dirección</h4>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                    <button type="button" @click="AgregarDireccion(figura);"
                                                        class="btn btn-primary"><i class="fa fa-plus-circle"></i>
                                                        Agregar</button>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-4">
                                                <div v-show="figura.ArrayPartes.length">
                                                    <nav>
                                                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                            <a v-for="(direccion, index3) in figura.ArrayPartes"
                                                                class="nav-link"
                                                                :class="{ 'active': direccion.Active, 'text-secondary': !direccion.Active }"
                                                                :key="index3"
                                                                @click="ManageTabs(figura.ArrayPartes, index3)"
                                                                style="cursor: pointer;">
                                                                Dirección {{ index3 + 1 }}
                                                            </a>
                                                        </div>
                                                    </nav>
                                                    <div class="tab-content" id="nav-tabContent-figtransp">
                                                        <div v-for="(direccion, index3) in figura.ArrayPartes"
                                                            :class="'tab-pane fade' + (direccion.Active ? 'show active' : '')"
                                                            :key="index3" :id="'direccionft_' + index3" role="tabpanel"
                                                            :aria-labelledby="'direccionft_tab_' + index3">
                                                            <div class="container-tab">
                                                                <div
                                                                    class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-2 text-end">
                                                                    <button type="button" v-b-tooltip.hover.Top
                                                                        title="Borrar dirección"
                                                                        @click="BorrarDireccion(figura, index3)"
                                                                        class="btn btn-danger"><i
                                                                            class="fa fa-trash"></i></button>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPCalle' + index2 + '_' + index3"
                                                                            class="form-label">Calle</label>
                                                                        <input :name="'FPCalle' + index2 + '_' + index3"
                                                                            :id="'FPCalle' + index2 + '_' + index3" type="text"
                                                                            class="form-control" v-model="direccion.Calle">
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPNumeroExt' + index2 + '_' + index3"
                                                                            class="form-label">Numero
                                                                            Exterior</label>
                                                                        <input :name="'FPNumeroExt' + index2 + '_' + index3"
                                                                            :id="'FPNumeroExt' + index2 + '_' + index3"
                                                                            type="text" v-model="direccion.NumeroExt"
                                                                            class="form-control">
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPNumeroInt' + index2 + '_' + index3"
                                                                            class="form-label">Numero
                                                                            Interior</label>
                                                                        <input :name="'FPNumeroInt' + index2 + '_' + index3"
                                                                            :id="'FPNumeroInt' + index2 + '_' + index3"
                                                                            type="text" v-model="direccion.NumeroInt"
                                                                            class="form-control" maxlength="16">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPCodigoPostal' + index2 + '_' + index3"
                                                                            class="form-label">Código Postal*</label>
                                                                        <input :name="'FPCodigoPostal' + index2 + '_' + index3"
                                                                            :id="'FPCodigoPostal' + index2 + '_' + index3"
                                                                            type="text" v-model="direccion.CodigoPostal"
                                                                            class="form-control" maxlength="16">
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPPais' + index2 + '_' + index3"
                                                                            class="form-label">País*</label>
                                                                        <select :name="'FPPais' + index2 + '_' + index3"
                                                                            :id="'FPPais' + index2 + '_' + index3"
                                                                            v-model="direccion.Pais"
                                                                            class="form-control form-select"
                                                                            @change="GetCmbList('estado', direccion, direccion.Pais);">
                                                                            <option value="">Seleccione una opción</option>
                                                                            <option
                                                                                v-for="(item, index4) in DataInicial.pais"
                                                                                :key="index4" :value="item.Clave">
                                                                                {{ item.Clave }} - {{ item.Nombre }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPEstado' + index2 + '_' + index3"
                                                                            class="form-label">Estado*</label>
                                                                        <select :name="'FPEstado' + index2 + '_' + index3"
                                                                            :id="'FPEstado' + index2 + '_' + index3"
                                                                            v-model="direccion.Estado"
                                                                            class="form-control form-select"
                                                                            @change="GetCmbList('municipio', direccion, direccion.Estado);">
                                                                            <option value="">Seleccione una opción</option>
                                                                            <option
                                                                                v-for="(elem, indexEst) in direccion.ListaEstados"
                                                                                :key="indexEst" :value="elem.Clave"> {{
                                                                                    elem.Clave + ' - ' + elem.Nombre }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPMunicipio' + index2 + '_' + index3"
                                                                            class="form-label">Municipio</label>
                                                                        <select :name="'FPMunicipio' + index2 + '_' + index3"
                                                                            :id="'FPMunicipio' + index2 + '_' + index3"
                                                                            v-model="direccion.Municipio"
                                                                            class="form-control form-select"
                                                                            @change="GetCmbList('colonia', direccion, direccion);">
                                                                            <option value="">Seleccione una opción</option>
                                                                            <option
                                                                                v-for="(elem, indexMun) in direccion.ListaMunicipios"
                                                                                :key="indexMun" :value="elem.Clave"> {{
                                                                                    elem.Clave + ' - ' + elem.Nombre }}</option>
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPColonia' + index2 + '_' + index3"
                                                                            class="form-label">Colonia</label>
                                                                        <select :name="'FPColonia' + index2 + '_' + index3"
                                                                            :id="'FPColonia' + index2 + '_' + index3"
                                                                            v-model="direccion.Colonia"
                                                                            class="form-control form-select">
                                                                            <option value="">Seleccione una opción</option>
                                                                            <option
                                                                                v-for="(elem, indexCol) in direccion.ListaColonias"
                                                                                :key="indexCol" :value="elem.Clave"> {{
                                                                                    elem.Clave + ' - ' + elem.Nombre }}</option>
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                        <label :for="'FPLocalidad' + index2 + '_' + index3"
                                                                            class="form-label">Localidad</label>
                                                                        <select :name="'FPLocalidad' + index2 + '_' + index3"
                                                                            :id="'FPLocalidad' + index2 + '_' + index3"
                                                                            v-model="direccion.Localidad"
                                                                            class="form-control form-select">
                                                                            <option value="">Seleccione una opción</option>
                                                                            <option
                                                                                v-for="(elem, indexLoc) in direccion.ListaLocalidad"
                                                                                :key="indexLoc" :value="elem.IdLocalidad"> {{
                                                                                    elem.Clave + ' - ' + elem.Nombre }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                                        <label :for="'FPReferencia' + index2 + '_' + index3"
                                                                            class="form-label">Referencia</label>
                                                                        <textarea :name="'Referencia' + index2 + '_' + index3"
                                                                            :id="'Referencia' + index2 + '_' + index3"
                                                                            v-model="direccion.Referencia"
                                                                            class="form-control" rows="2"
                                                                            maxlength="250"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Configs from '@/helpers/VarConfig.js';
const SPINNER = 'spinner-border spinner-border-sm';
const MAGNIFIER = 'fa fa-search';
const EmitEjecuta = 'seccionFiguratransporte';

export default {
    name: 'FormTransporte',
    props: ['DataInicial', 'pListaFiguras', 'poBtnSave', 'pErrorValidacion'],
    components: {},
    data() {
        return {
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'routerhaciaatras',
                EmitSeccion: 'EmitEjecuta',
            },
            ObjFigura: {
                IdFiguraTransp: 0,
                TipoFigura: '',
                RFCFigura: '',
                NumLicencia: '',
                NombreFigura: '',
                NumRegIdTribFigura: '',
                ResidenciaFiscalFigura: '',
                IdChofer: '',
                ArrayPartes: [],
                //Helpers
                AutocompChoferList: [],
                IconSearch: MAGNIFIER,
                Active: false,
            },
            ObjDireccion: {
                Calle: '',
                NumeroExt: '',
                NumeroInt: '',
                Colonia: '',
                Localidad: '',
                Referencia: '',
                Municipio: '',
                Estado: '',
                Pais: '',
                CodigoPostal: '',
                //Helpers
                ListaEstados: [],
                ListaMunicipios: [],
                ListaColonias: [],
                ListaLocalidad: [],
                Active: false,
            },
            ListaFiguras: [],
            ListaFigCanceladas: [],
            //Helpers
            TimeOutSearch: null,
            LimDir: 1, // Número limite maximo de direcciones permitidas por cada figura

            segurity: {},
            masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            Emit: EmitEjecuta,
        }
    },
    methods:
    {
        // Maneja los estados de los tabs y paneles.
        ManageTabs(List, index) {
            List.forEach((elem, i) => {
                if (i === index) {
                    elem.Active = true;
                } else {
                    elem.Active = false;
                }
            })
        },
        // Agrega una figura vacía.
        AgregarFigura() {
            let isActive = false;
            if (this.ListaFiguras.length <= 0) {
                isActive = true;
            }
            let newObjFigura = JSON.parse(JSON.stringify(this.ObjFigura));
            newObjFigura.Active = isActive;
            this.ListaFiguras.push(newObjFigura);
        },
        // Autocompletado para Figura.
        AutocompChofer(item) {
            clearTimeout(this.TimeOutSearch);
            this.TimeOutSearch = setTimeout(() => {
                const MINLENGTH = 0;
                const KEYWORD = item.NombreFigura;
                if (KEYWORD.length > MINLENGTH) {
                    item.IconSearch = SPINNER;
                       
                    this.$http.get('cpChoferesAutocomp/',{
                        params: {
                        TxtBusqueda: KEYWORD,
                    }
                    })
                    .then((res) => {
                        item.AutocompChoferList = res.data.data;
                    }).finally(() => {
                        item.IconSearch = MAGNIFIER;
                    })
                } else {
                    item.AutocompChoferList = []
                }
            }, 750);
        },
        // Rellena el objeto Figura con la data recuperada.
        SetDataChoferFig(item, id) {
            if (id) {
                this.$http.get('cpChoferes/' + id).then((res) => {
                    // Object.assign(item, res.data.data)
                    let resp = res.data.data;

                    // Data del chofer
                    item.NombreFigura = `${resp.Nombre} ${resp.ApellidoPat} ${resp.ApellidoMat}`;
                    item.RFCFigura = resp.RFC
                    item.IdChofer = resp.IdChofer;
                    item.NumLicencia = resp.NumLicencia;

                    // Se crea un nueva parte (direccion)
                    if (item.ArrayPartes.length <= 0) {
                        this.AgregarDireccion(item)
                    }
                    let parte = item.ArrayPartes[0]

                    // Data de la parte
                    parte.NumeroExt = resp.NumExt;
                    parte.NumeroInt = resp.NumInt;
                    parte.Referencia = resp.Referencias
                    let keys = ['Calle', 'Estado', 'CodigoPostal', 'Pais', 'Municipio', 'Colonia', 'Localidad'];
                    keys.forEach(elem => {
                        if (resp[elem]) {
                            parte[elem] = resp[elem];
                        }
                    })
                    this.$http.get("cpDataCombosUbicacion", {
                        params: {
                            Pais: parte.Pais,
                            Estado: parte.Estado,
                            Municipio: parte.Municipio,
                        }
                    }).then((res) => {
                        parte.ListaEstados = res.data.data.ListEstado;
                        parte.ListaMunicipios = res.data.data.ListMunicipio;
                        parte.ListaLocalidad = res.data.data.ListLocalidad;
                        parte.ListaColonias = res.data.data.ListColonia;
                    }).catch(err => console.error(err));
                }).catch((err) => {
                    this.$toast.error(err.response.data.message);
                }).finally(() => item.AutocompChoferList = []);


            } else {
                console.error('error, el chofer no se encuentra en la base de datos');
            }
        },
        // Borra la figura indicada.
        BorrarFigura(Index) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    // En caso de que la figura eliminada ya existiera en se prepara para borrarla de la base de datos.
                    if (this.ListaFiguras[Index].IdFiguraTransp > 0) {
                        let FiguraCancelada = { IdFiguraTransp: this.ListaFiguras[Index].IdFiguraTransp };
                        this.ListaFigCanceladas.push(FiguraCancelada)
                    }
                    // Elimina el item de ListaFiguras
                    this.ListaFiguras.splice(Index, 1)
                    this.ListaFiguras.forEach(elem => elem.Active = false)

                    // Establece quien sera el tab de Figura activo
                    let newIndex = Index;
                    if ((Index === this.ListaFiguras.length) && Index > 0) {
                        newIndex = this.ListaFiguras.length - 1;
                    }
                    if (this.ListaFiguras.length > 0) {
                        this.ListaFiguras[newIndex].Active = true;
                    }
                }
            });
        },
        // Agrega una dirección vacía.
        AgregarDireccion(Item) {
            let isActive = false;
            if (Item.ArrayPartes.length >= this.LimDir) {
                this.$swal(Configs.configMaxRegistros);
            } else {
                if (Item.ArrayPartes.length <= 0) {
                    isActive = true;
                }
                const newObjDireccion = {
                    Calle: '',
                    NumeroExt: '',
                    NumeroInt: '',
                    Colonia: '',
                    Localidad: '',
                    Referencia: '',
                    Municipio: '',
                    Estado: '',
                    Pais: '',
                    CodigoPostal: '',
                    //Helpers
                    ListaEstados: [],
                    ListaMunicipios: [],
                    ListaColonias: [],
                    ListaLocalidad: [],
                    Active: isActive,
                }
                Item.ArrayPartes.push(newObjDireccion);
            }
        },
        // Borra la dirección indicada.
        BorrarDireccion(Item, Index) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    Item.ArrayPartes.splice(Index, 1)
                }
            });
        },
        // Rellena los combos select para Estado, Municipio, Colonia y Localidad.
        GetCmbList(Tipo, Item, Criterio) {
            const sinCriterio = Criterio == '';

            switch (Tipo) {
                case 'estado':
                    Item.ListaEstados = [];
                    sinCriterio ? Item.ListaEstados = [] : this.DataInicial.getComboList(Item.ListaEstados, Tipo, Criterio, this);
                    Item.ListaMunicipios = [];
                    Item.ListaLocalidad = [];
                    Item.ListaColonias = [];
                    Item.Estado = '';
                    Item.Municipio = '';
                    Item.Localidad = '';
                    Item.Colonia = '';
                    break;

                case 'municipio':
                    Item.ListaMunicipios = [];
                    Item.ListaLocalidad = [];
                    if (!sinCriterio) {
                        this.DataInicial.getComboList(Item.ListaMunicipios, Tipo, Criterio, this);
                        this.DataInicial.getComboList(Item.ListaLocalidad, 'localidad', Criterio, this);
                    }
                    Item.ListaColonias = [];
                    Item.Municipio = '';
                    Item.Localidad = '';
                    Item.Colonia = '';
                    break;

                case 'colonia':
                    Item.ListaColonias = [];
                    sinCriterio ? Item.ListaColonias = [] : this.DataInicial.getComboList(Item.ListaColonias, Tipo, Criterio, this);
                    Item.Colonia = '';
                    break;

                case 'localidad':
                    Item.ListaLocalidad = [];
                    sinCriterio ? Item.ListaLocalidad = [] : this.DataInicial.getComboList(Item.ListaLocalidad, Tipo, Criterio, this);
                    Item.Colonia = '';
                    break;
            }
        },
        SetearDataRecov() {
            if (this.pListaFiguras.length >= 1) {
                this.pListaFiguras.forEach((elem, index) => {
                    let newFigura = JSON.parse(JSON.stringify(this.ObjFigura));
                    newFigura.Active = index === 0 ? true : false;
                    Object.assign(newFigura, elem)
                    if (newFigura.ArrayPartes.length >= 1) {
                        newFigura.ArrayPartes.forEach((parte, i) => {
                            parte.Active = i === 0 ? true:false;
                            parte.ListaEstados = [];
                            parte.ListaMunicipios = [];
                            parte.ListaLocalidades = [];
                            parte.ListaColonias = [];
                        })
                    }
                    this.ListaFiguras.push(JSON.parse(JSON.stringify(newFigura)));
                    let targetFig = 0;
                })
                this.SetCombosUbicacionPartes();
            }
        },
        SetCombosUbicacionPartes(){
            this.ListaFiguras.forEach(elem => {
                elem.ArrayPartes.forEach(async parte => {
                    await this.$http.get("cpDataCombosUbicacion",{
                        params:{
                            Pais:parte.Pais,
                            Estado:parte.Estado,
                            Municipio:parte.Municipio,
                            kew:true,
                        }
                    }).then((res)=>{
                        parte['ListaEstados'] = res.data.data.ListEstado;
                        parte.ListaMunicipios = res.data.data.ListMunicipio;
                        parte.ListaLocalidades = res.data.data.ListLocalidad;
                        parte.ListaColonias = res.data.data.ListColonia;
                    }).catch(err => console.error(err));
                })
            })
        },
        Limpiar() {
            this.ListaFiguras = [];
            this.ListaFigCanceladas = [];
            this.errorvalidacion = [];
        },
    },
    computed: {
        ValidateFigTransp() {
            if (this.pErrorvalidacion != undefined) {
                this.errorvalidacion = this.pErrorvalidacion;
            }
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
    },
    mounted() {
        if (this.poBtnSave != undefined) {
            this.oBtnSave = this.poBtnSave;
        }
        this.Limpiar();
        this.SetearDataRecov();
    }
}
</script>